import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const DevTeaser = () => (
  <section className="py-24" data-testid="dev-teaser-section">
    <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
      <div>
        <p className="eyebrow">05 — Developers</p>
        <h2 className="mt-4 text-3xl font-semibold tracking-[-0.02em] text-white sm:text-4xl">TRACE analytics, via API.</h2>
        <p className="mt-5 max-w-lg text-base text-trace-muted">
          We are planning a REST API for developers and trading tools. Preview the proposed endpoints and join the early-access list.
        </p>
        <Link to="/developers" data-testid="dev-teaser-link"
          className="mt-8 inline-flex items-center gap-2 rounded-full border border-trace-line bg-trace-card px-5 py-2.5 text-sm text-white transition-colors hover:border-trace-green/40">
          Preview the API <ArrowRight size={14} />
        </Link>
      </div>
      <pre className="overflow-x-auto rounded-xl border border-trace-line bg-trace-panel p-6 font-mono text-xs leading-relaxed text-trace-muted" aria-label="Example API request (planned)">
        <span className="text-trace-dim"># planned — not yet available</span>{"\n"}
        <span className="text-trace-green">GET</span> /v1/tokens/{"{mint}"}/risk{"\n\n"}
        {"{"}{"\n"}  "mint_authority": null,{"\n"}  "freeze_authority": null,{"\n"}  "signals": [ ... ],{"\n"}  "fetched_at": "…"{"\n"}{"}"}
      </pre>
    </div>
  </section>
);
